<script lang="ts">
	interface Props {
		width: number
		height: number | null | undefined
		aspectRatio: number | undefined
	}

	let { width, height, aspectRatio }: Props = $props()

	let svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${
		height ?? (aspectRatio ? width / aspectRatio : 0)
	}"></svg>`
</script>

<img
	style:display="block"
	style:width="100%"
	alt=""
	aria-hidden="true"
	src="data:image/svg+xml;base64,{btoa(svg)}"
/>
